import React from 'react'
import Page from 'reason/settings/pages/AccountSettingsPage.bs'
import { requireAuthenticatedAgent } from '../../hoc/AuthenticatedComponent'
import { withMainLayout } from '../../pagesComponents/MainApp'
import { useRouter } from 'next/router'

const AccountSettingsPage_ = () => {
  const router = useRouter()
  const { setting } = router.query

  // Setting is optional, so we use [[...setting]], which becomes an array
  return <Page setting={setting} />
}

const AccountSettingsPage = requireAuthenticatedAgent(AccountSettingsPage_)

AccountSettingsPage.getLayout = withMainLayout

export default AccountSettingsPage
